import { ApplicationElement, html } from '@beunity/lit-components';

import style from './style.lit.css';

const allTypes = {
  image: ['jpeg', 'jpg', 'png', 'webp', 'gif', 'tif', 'ico', 'svg'],
  audio: ['mp3', 'weba', 'wav'],
  presentation: ['pdf', 'ppt', 'odp', 'pptx'],
  doc: ['doc', 'docx', 'odt'],
  sheet: ['ods', 'xls', 'xlsx', 'csv'],
};

const fileType = {};

Object.entries(allTypes).forEach(([type, extensions]) =>
  extensions.forEach(ext => (fileType[ext] = type))
);

/**
 * An icon for a specified file type. The icon (by default dark gray) will have a different background color if it is recognized as one of the following file types:
 * - image: `['jpeg', 'jpg', 'png', 'webp', 'gif', 'tif', 'ico', 'svg']`
 * - audio: `['mp3', 'weba', 'wav']`
 * - presentation: `['pdf', 'ppt', 'odp', 'pptx']`
 * - doc: `['doc', 'docx', 'odt']`
 * - sheet: `['ods', 'xls', 'xlsx', 'csv']`
 *
 * Useful tips:
 * - Passing css prop `--file-icon-width` will automatically set a good `--file-icon-height` value.
 * - While passing css prop `--file-icon-font-size`, assume the extension is **3 letters long** and the component will **automatically scale down** for 4 or 5 letter extensions
 *
 * @prop ext - Extension of the file
 *
 * @cssprop [--file-icon-width: 30px] - Icon's width
 * @cssprop [--file-icon-height: calc(var(--file-icon-width) * 1.33)] - Icon's height
 * @cssprop [--file-icon-text-color: var(--contrast-light)] - Text color
 * @cssprop [--file-icon-font-size: var(--font-size-base)] - Icon's text size
 * @cssprop [--file-icon-parent-background: var(--body-bg)] - Necessary for proper "folded-corner effect"
 */

export default class FileIcon extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    ext: { type: String },
  };

  constructor() {
    super();
    this.ext = '';
  }

  render() {
    return html`
      <div class="wrapper ${fileType[this.ext]}">
        <div class="folded-corner"></div>
        <div class="extension len-${this.ext.length}">${this.ext}</div>
      </div>
    `;
  }
}

customElements.get('bu-file-icon') ||
  customElements.define('bu-file-icon', FileIcon);
